'use client'

import type { ReactNode } from 'react'
import { FreeDownloadButton } from '@/AddToCartButton'
import type { AdvertisingModalContent } from '@/AdvertisingModal/types'
import { useStore } from '@/store'
import type { FreemagicJumbotronEmbeddedProps } from './FreemagicJumbotronEmbedded'
import { FreemagicJumbotronEmbedded } from './FreemagicJumbotronEmbedded'

type Props = {
  productSlug: string
  productGrantLabel: string
  loggedInTitle: string
  loggedInBody: ReactNode
  freeDownloadName: string
  layout: 'side-by-side' | 'stacked'
  howSignedUp?: number
  claimPath?: string
  hideForLoggedInUsers?: boolean
  showFormForLoggedInUsers?: boolean
  enableCaptcha?: boolean
  content: Omit<AdvertisingModalContent, 'formFields'>
  embeddedClassName?: string
  customerIo?: FreemagicJumbotronEmbeddedProps['customerIo']
}

export function FreemagicFreeProductSignup({
  productSlug,
  productGrantLabel,
  loggedInTitle,
  loggedInBody,
  freeDownloadName,
  layout,
  howSignedUp = 1,
  claimPath,
  hideForLoggedInUsers,
  showFormForLoggedInUsers,
  enableCaptcha,
  content,
  embeddedClassName,
  customerIo,
}: Props) {
  const user = useStore(state => state.user)
  const claimRedirectPath = claimPath ?? `/product/${productSlug}`
  const loginToClaim = `/account/login?redirect=${encodeURIComponent(claimRedirectPath)}`

  if (user) {
    return (
      <div className="border-[10px] border-solid border-[#28a745] bg-[#eee] px-4 pb-4 pt-4 text-[#212529]">
        <h2 className="mt-2 text-2xl font-medium leading-tight text-[#212529]">
          {loggedInTitle}
        </h2>
        <div className="mb-0 text-[#212529]">{loggedInBody}</div>
        <hr className="my-4 border-0 border-t border-black/10" />
        <FreeDownloadButton
          productSlug={productSlug}
          productName={productGrantLabel}
          className="w-full py-3 text-lg mt-2"
        />
      </div>
    )
  }

  return (
    <FreemagicJumbotronEmbedded
      content={content}
      freeDownloadName={freeDownloadName}
      layout={layout}
      howSignedUp={howSignedUp}
      hideForLoggedInUsers={hideForLoggedInUsers}
      showFormForLoggedInUsers={showFormForLoggedInUsers}
      enableCaptcha={enableCaptcha}
      successRedirectUrl={loginToClaim}
      embeddedClassName={embeddedClassName}
      customerIo={customerIo}
    />
  )
}
